import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import cn from 'classnames';
import { IconAlert, IconCheck, IconChevronDown, IconChevronUp, IconInfo } from '../../../icons';
import { elevateClass, Enum, Intent, intentClass, useSpacingProps, maxWidthClass, isDefined, isTruthy } from '../../../library';
import { Button } from '../../../components/button';
import { Close } from '../../../components/close';
import { UncontrolledMessage } from './uncontrolled-message';
import { MessageGroupContext } from './message-group';
var messageClasses = {
  MAIN: 'message',
  WRAPPER: 'message__inner',
  BODY: 'message__body',
  HEADING: 'message__heading',
  ACTION: 'message__action',
  ICON: 'message__icon',
  TRIGGERS: 'message__triggers'
};
export var MessageAppearanceType = Enum({
  MINIMAL: 'minimal',
  OUTLINE: 'outline',
  FILL: 'fill'
});
export var MessageSizeType = Enum({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
});
export var Message = function Message(props) {
  var _mergedProps$initialC, _props$children;
  var groupProps = React.useContext(MessageGroupContext);
  var defaultProps = {
    elevate: 0
  };
  var mergedProps = _objectSpread(_objectSpread(_objectSpread({}, defaultProps), groupProps), props);
  var _useSpacingProps = useSpacingProps(props),
    marginClasses = _useSpacingProps.marginClasses,
    paddingClasses = _useSpacingProps.paddingClasses;
  var _React$useState = React.useState((_mergedProps$initialC = mergedProps.initialCollapsed) !== null && _mergedProps$initialC !== void 0 ? _mergedProps$initialC : false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isCollapsed = _React$useState2[0],
    setIsCollapsed = _React$useState2[1];
  var className = cn(messageClasses.MAIN, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "-".concat(mergedProps.appearance), mergedProps.appearance), "-".concat(mergedProps.size), mergedProps.size), "-".concat(mergedProps.density), mergedProps.density && mergedProps.density !== 'normal'), '-banner', mergedProps.isBanner), '-inline', mergedProps.isInline), elevateClass(mergedProps.elevate), intentClass(mergedProps.intent), marginClasses, paddingClasses, mergedProps.className);
  var wrapperClassNames = cn(messageClasses.WRAPPER, maxWidthClass(mergedProps.bodyMaxWidth));
  if (props.isDismissed) return null;
  var defaultIcon = null;
  switch (mergedProps.intent) {
    case Intent.NONE:
    case Intent.INFO:
    case Intent.PRIMARY:
      defaultIcon = React.createElement(IconInfo, {
        size: mergedProps.size
      });
      break;
    case Intent.SUCCESS:
      defaultIcon = React.createElement(IconCheck, {
        size: mergedProps.size
      });
      break;
    case Intent.WARNING:
    case Intent.DANGER:
      defaultIcon = React.createElement(IconAlert, {
        size: mergedProps.size
      });
      break;
  }
  return React.createElement("div", {
    className: className
  }, React.createElement("div", {
    className: wrapperClassNames
  }, props.showIcon || !!props.icon && props.showIcon !== false ? React.createElement("div", {
    className: "message__icon"
  }, props.icon || defaultIcon) : null, React.createElement("div", {
    className: messageClasses.BODY
  }, isTruthy(props.heading) && React.createElement("div", {
    className: messageClasses.HEADING,
    children: props.heading
  }), props.isCollapsible && isCollapsed ? null : (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : props.text), props.onAction && props.actionText ? React.createElement("div", {
    className: messageClasses.ACTION
  }, React.createElement(Button, {
    size: mergedProps.size,
    density: mergedProps.density,
    label: props.actionText,
    intent: props.intent,
    onClick: props.onAction
  })) : null, (props.isCollapsible || isDefined(props.onDismiss)) && React.createElement("div", {
    className: messageClasses.TRIGGERS
  }, props.isCollapsible && React.createElement(Button, {
    size: "small",
    density: "compact",
    isSquare: true,
    appearance: "minimal",
    shape: "circular",
    title: "Expand/Collapse",
    onClick: function onClick() {
      return setIsCollapsed(!isCollapsed);
    },
    intent: mergedProps.appearance === MessageAppearanceType.FILL ? mergedProps.intent : Intent.NONE
  }, isCollapsed ? React.createElement(IconChevronDown, null) : React.createElement(IconChevronUp, null)), isDefined(props.onDismiss) && React.createElement(Close, {
    intent: mergedProps.appearance === MessageAppearanceType.FILL ? mergedProps.intent : Intent.NONE,
    onClick: props.onDismiss
  }))));
};
Message.displayName = 'Message';
Message.defaultProps = {};
Message.Uncontrolled = UncontrolledMessage;